import React from 'react'
import LiveTemplateDefault from 'src/components/template/live/canada'
import { canadaPlanSet, canadaSports_EPL_UCL_Override } from 'src/constants/planData/canadaPlanData'
export default (props) => (
  <LiveTemplateDefault
    location={props.location}
    lang="en"
    market="canada"
    callsign="BEINCHD"
    title="Watch beIN SPORTS with Fubo"
    networkSet="canadaEssentials"
    customNetworks={['fsn']}
    planCardsConfig={{
      plans: canadaPlanSet.sports,
      overrides: canadaSports_EPL_UCL_Override,
    }}
  />
)
